import { useState, useEffect } from "react";
import moment from "moment";
import {useSelector} from "react-redux";
import { getBusinessPartnerModel } from "../../BusinessPartner/Infrastructure/BusinessPartner.reducer";
import { makeStyles } from "@mui/styles";
import {useHistory, useParams} from "react-router-dom";
import ChevronLeftOutlinedIcon from "@mui/icons-material/ChevronLeftOutlined";
import AddIcon from "@mui/icons-material/Add";
import FlatIconButton from "../../DesignSystem/FlatButton";
import BasicDatePicker from "../../DesignSystem/BasicDatePicker";
import ModalAlert from "../../DesignSystem/ModalAlert"
import bgRoadMap from "../../assets/bg-map.png";
import InputOutlined from "../../DesignSystem/InputOutlined";
import { UserSignUp } from "../../Auth/Infrastructure/Auth.presenter";
import { validateEmail, validatePhone, validateText, validateZipCode} from "../Domain/User.model";
import ValidationCode from "./ValidationCode";
import ModalPassword from "../../DesignSystem/ModalPassword";

const registerBtn={
  fontSize: "0.875rem",
  border: "2px solid white",
  filter: "drop-shadow(0px 4px 4px rgba(130, 130, 130, 0.25))"
}

const datePickerStyles = {
  maxWidth: "600px",
  width: "100%",
  height: "36px",
  borderRaduis: "5px"
}

const useStyles = makeStyles((theme) => ({
  registerDeliveryContainer: {
    minHeight: "100vh",
    height: "auto",
    background: theme.palette.primary.main,
    backgroundImage: `url(${bgRoadMap})`,
    display: "flex",
    justifyContent: "flex-start",
    alignContent: "center",
    flexDirection: "column",
    gap: 60,
    paddingBottom: 70
  },
  headerRegister: {
    paddingTop: 30,
    paddingLeft: 15,
    color: "white",
    display: "flex",
    justifyContent: "flex-start",
    gap: 50,
    [theme.breakpoints.up("md")]:{
      justifyContent: "center",
      display: "none"
    },
  },
  titleDesk:{
    fontSize: "3rem",
    lineHeight: "58.09px",
    [theme.breakpoints.down("md")]:{
      display: "none"
    },
    [theme.breakpoints.up("md")]:{
      gridColumn: "1/-1"
    }
  },
  formStyles: {
    width: "100%",
    maxWidth: "780px",
    minHeight: 950,
    margin: "auto",
    position: "relative",
    padding: "80px 10px 30px",
    background: "white",
    borderRadius: 10,
    height: "auto",
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    flexDirection: "column",
    gap: 15,
    [theme.breakpoints.up("md")]: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      borderRadius: "8px",
      padding: "21px 94px 40px",
      columnGap: 47
    },
  },
  addProfileImage: {
    position: "absolute",
    top: "-45px",
    left: "calc(50% - 45px)",
    width: 90,
    height: 90,
    borderRadius: "50%",
    background: "#C4C4C4",
    display: "flex",
    justifyContent: " center",
    alignItems: "center",
    color: "white",
    border: "2px solid white",
    "&:hover":{
      cursor: "pointer",
      background: "#ABABAB"
    },
    [theme.breakpoints.up("md")]:{
      position: "static",
      width: 131,
      height: 131,
      borderRadius: 5,
      gridColumn: "1/-1"
    },
    [theme.breakpoints.up("lg")]:{
      gridColumn: "1/-1"
    }
  },
  doubleInputContainer: {
    display: "flex",
    height: "auto",
    width: "100%",
    justifyContent: "space-between",
    gap: 7,
    [theme.breakpoints.up("md")]:{
      gap: 47,
      justifyContent: "space-between",
      gridColumn: "1/-1",
    }
  },
  smallInputContainer:{
    [theme.breakpoints.down("md")]:{
      maxWidth: 161,
    }
  },
  inputContainer: {
    width: "100%",
    [theme.breakpoints.up("md")]:{
      maxWidth: 290,
    }
  },
  addresInputContainer:{
    width: "100%",
    [theme.breakpoints.up("md")]:{
      gridColumn: "1/-1"
    }
  },
  labelStyles:{
    fontSize: "1.125rem",
    fontWeight: 500,
    color: "#333333"
  },
  btnContainer:{
    width: "100%",
    display: "flex",
    justifyContent: "center",
    gap: 25,
    [theme.breakpoints.up("md")]:{
      gridColumn: "1/-1",
    }
  },
  inputStyles:{
    width: "100%",
  },
  labelDate: {
    width: "100%",
    alignSelf: "start",
    fontWeight: 500,
    fontSize: "1.125rem",
    marginBottom: 5,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"

  },
  photoProfile:{
    borderRadius: "50%",
    width: "100%",
    height: "100%",
    objectFit: "cover",
    zIndex: "10",
    "&:hover":{
      opacity: 0.2,
      cursor: "pointer"
    }
  }
}));

export default function UserRegisterUI() {
  const classes = useStyles();
  const history = useHistory();
  const {roleUser} = useParams();
  const [sending, setSending] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [photo, setPhoto] = useState(null);
  const [photoPreview, setPhotoPreview] = useState();
  const businessPartner = useSelector(getBusinessPartnerModel);
  const userRegisterRole = roleUser === "delivery" ? "deliveryman" : "afiliador";
  const [isOpenAlert, setOpenAlert] = useState(false);
  const [titleAlert, setTitleAlert] = useState("Ha ocurrido un error");
  const [isError, setError] = useState(false);
  const [response, setResponse] = useState({});

  const [formValues, setFormValues] = useState({
    name: "",
    lastName: "",
    sex: "",
    email: "",
    phone: "",
    address: "",
    zipCode: "",
    city: "",
    state: "",
    role: userRegisterRole,
    birthDate: moment(new Date()).format("YYYY-MM-DD")
  });

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    window.addEventListener("load", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
      window.addEventListener("load", handleResize);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleResize = () => {
    const screenWidth = window.innerWidth;
    if (screenWidth <= 768) {
      history.push(`/personal/${roleUser === "delivery" ? "repartidores" : "asesores" }`)
    }
  };

  const handleClose = () => {
    setPhotoPreview(null);
    setSending(false);
  };

  const fieldsValidate = () => {
    const emailResult = validateEmail(formValues.email);
    const nameResult = validateText(formValues.name);
    const lastNameResult = validateText(formValues.lastName);
    const sexResult = formValues.sex !== "";
    const phoneResult = validatePhone(formValues.phone);
    const streetResult = formValues.street !== "";
    const outdoorNumberResult = formValues.outdoorNumber !== "";
    const zipCodeResult = validateZipCode(formValues.zipCode);
    const cityResult = validateText(formValues.city);
    const stateResult = validateText(formValues.state);

    return {emailResult, nameResult, lastNameResult, sexResult, phoneResult, streetResult, outdoorNumberResult, zipCodeResult,cityResult, stateResult}
  }

  const handlePhotoChange = (e) => {
    const allowedExtensions = /(.jpg|.jpeg|.png)$/i;
    if (!allowedExtensions.exec(e.target.files[0].name)) {
      alert("Elige un formato de imagen válido (.jpg, .png, .jpeg)");
    } else {
      setPhoto(e.target.files[0]);
      setPhotoPreview(URL.createObjectURL(e.target.files[0]));
    }
  }; 

  function selectPhoto() {
    const fileInput = document.createElement("input");
    fileInput.type = "file";
    fileInput.accept = ".png,.jpg,.jpeg";
    fileInput.addEventListener("change", (event) => {
      handlePhotoChange(event);
    });
    fileInput.click();
    fileInput.remove();
  }

  const showAlertModal = () => setOpenAlert(true);

  const handleClickOpen = (alertState) => {
    setOpenAlert(alertState);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const valid = fieldsValidate();
    const bsPartnerZone = businessPartner.zone;
    if(valid.nameResult && valid.lastNameResult && valid.sexResult && valid.emailResult && validatePhone && valid.zipCodeResult && valid.cityResult && valid.outdoorNumberResult && valid.streetResult && valid.stateResult){ 
      setFormValues({...formValues, zone: bsPartnerZone, role: userRegisterRole, photo: photo})
      setError(false);
      try {
        setSending(true);
        const {id, temporaryPass} = await UserSignUp({...formValues, zone: bsPartnerZone, photo: photo});
        setResponse({id,temporaryPass});
        setSending(false);
        setActiveStep(1);
      } catch (error) {
        setError(true);
        setSending(false);
        setTitleAlert(error.message);
        showAlertModal();
      }
    }else{
      setError(true);
      setTitleAlert("Ingresa los datos correctamente" )
      showAlertModal();
    }
  }

  const getInputValue = (key, value) => {
    setFormValues({ ...formValues, [key]: value});
  };

  const getDatePickerValue = (date) =>{
    const formatedDate = moment(new Date(date)).format("YYYY-MM-DD");
    setFormValues({...formValues, birthDate: formatedDate})
  }

  const handleValidationCodeSubmit = () => {
    setActiveStep(2);
  }

  const handleRegistration = () => {
    history.push(`/personal/${roleUser === "delivery" ? "repartidores" : "asesores" }`);
  }

  return (
    <>
    {activeStep === 0 &&
      <>
      <div className={classes.registerDeliveryContainer}>
      <div className={classes.headerRegister}>
        <ChevronLeftOutlinedIcon sx={{display: {md: "none"}}} onClick={() => {history.push(`/personal/${roleUser === "delivery" ? "repartidores" : "asesores" }`); handleClose()}}/>
        <h4>Agregar {roleUser === "delivery" ? "repartidor" : "asesor"}</h4>
      </div>
      <form className={classes.formStyles}>
        <h4 className={classes.titleDesk}>Agregar <br/> {roleUser === "delivery" ? "repartidor" : "asesor"} </h4>
        <div className={classes.addProfileImage}  onClick={selectPhoto}>  
          {photoPreview ? <img className={classes.photoProfile} src={photoPreview} alt="foto de perfil"/> : <AddIcon/>}
        </div>
        <InputOutlined labelTitle={`Nombre del ${roleUser === "delivery" ? "repartidor" : "asesor"}`} placeholderText="Nombre(s)" name="name" handleInputChange={getInputValue}/>
        <InputOutlined labelTitle="Apellido" placeholderText="Apellido" name="lastName" handleInputChange={getInputValue}/>
        <div className={classes.doubleInputContainer}>
          <div className={classes.inputStyles}>
            <p className={classes.labelDate}>Fecha nacimiento</p>
            <BasicDatePicker customStyles={datePickerStyles} variant="outlined" handleChange={getDatePickerValue}/>
          </div>
          <InputOutlined labelTitle="Sexo" placeholderText="" name="sex" handleInputChange={getInputValue}/>
        </div>
        <InputOutlined labelTitle="Correo electrónico" placeholderText="correo@example.com" name="email" handleInputChange={getInputValue}/>
        <InputOutlined labelTitle="Teléfono" placeholderText="" name="phone" handleInputChange={getInputValue}/>
        <div className={classes.doubleInputContainer}>
          <InputOutlined labelTitle="Calle" placeholderText="" name="street" handleInputChange={getInputValue}/>
          <InputOutlined labelTitle="Núm. exterior" placeholderText="" name="outdoorNumber" handleInputChange={getInputValue}/>
        </div>
        <InputOutlined labelTitle="Código postal" placeholderText="" name="zipCode" handleInputChange={getInputValue}/>
        <InputOutlined labelTitle="Ciudad" placeholderText="" name="city" handleInputChange={getInputValue}/>
        <InputOutlined labelTitle="Estado" placeholderText="" name="state" handleInputChange={getInputValue}/>
        <div className={classes.btnContainer}>
          <FlatIconButton isDisable={sending} widthBtn="290px" typeButton="button" title={sending ? "Enviando..." : "Registrar"} onClick={handleSubmit} customStyles={registerBtn}/>
        </div>
      </form>
    </div>
      </>
    }
    {activeStep === 1 && <ValidationCode data={formValues} codeSubmit={handleValidationCodeSubmit} id={response.id || ""}/>}
    {activeStep === 2 && <ModalPassword passwordSubmit={handleRegistration} tempPw={response.temporaryPass || ""}/>}
    <ModalAlert title={titleAlert} typeAlert={isError ? "error" : "success"} isOpen={isOpenAlert} handleAlert={handleClickOpen}/>
    </>
  );
}